<template>
  <div class="bindPage rightPage">
    <div class="layout">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        :inline="true"
        :optareBtn="optareBtn"
        :treePathObj="treePathObj"
        @resetFn="resetFn"
        @confirmFn="getListFn"
        @searchFn="getListFn"
        @netFn="netFn"
        @delFn="delFn"
        @editScopeFn="editScopeFn"
        @useAgainFn="useAgainFn"
      />
      <div class="componentPage">
        <!--                <STable :columns="columns" :req="relayList" :params="[SearchForm, 'stop']" ref="stable" @selectData="choozeTable"></STable>-->
        <StopTable
          :table-data="tableData"
          :loading="loading"
          @choozeTable="choozeTable"
          @delRowFn="delRowFn"
          @configFn="configFn"
          @editScopeRowFn="editScopeRowFn"
          @useAgainRowFn="useAgainRowFn"
          @carrierDetailFn="carrierDetailFn"
          @detailFn="detailFn"
        ></StopTable>
        <Pagination
          class="pagination"
          :total="total"
          :page.sync="SearchForm.iDisplayStart"
          :limit.sync="SearchForm.iDisplayLength"
          @pagination="getListFn"
        ></Pagination>
      </div>
    </div>
    <!-- 网络参数 -->
    <Net
      :isShow.sync="isShow"
      :title="title"
      :choozeTableData="choozeTableData"
      ref="net"
    />
    <!-- 修改范围 -->
    <EditScope
      :isShowEditShow.sync="isShowEditShow"
      :scopeArray="scopeArray"
      ref="scopedId"
    />
    <!-- 配置信息 -->
    <Config
      :isShowConfig.sync="isShowConfig"
      :title="title"
      :rowData="rowData"
      v-bind="$attrs"
      ref="config"
      v-if="isShowConfig"
    />

    <!-- 监测点详情 -->
    <MonitorDialog
      :visible.sync="dialogVisible"
      :carrier-info="carrierDetail"
    ></MonitorDialog>
  </div>
</template>

<script>
import formMixin from '@/utils/formMixins.js'
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'
import qs from 'qs'
import Net from '../components/VNet.vue'
import EditScope from '../components/EditScope.vue'
import Config from '../components/ConfigDialog.vue'
import { relayDel, relayEdit, relayList } from '@/api/modules/relay.js'
import { shareScope } from '@/api/modules/public.js'
import columns, { searchCondi } from '../config/stopTable'
import { carrierDetail } from '@/api/modules/carrier'
import StopTable from '@/pages/equipment/relay/stop/stopTable.vue'
import { getPermission } from '@/utils/permission'
import MonitorDialog from '@/pages/equipment/publicCom/MonitorDialog.vue'

export default {
  mixins: [formMixin, getAllTreePath],
  components: {
    StopTable,
    Net,
    EditScope,
    Config,
    MonitorDialog
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newval) {
        this.formContent[1].selectParam = newval
      },
      immediate: true
    }
  },
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    },
    columns () {
      return columns.call(this)
    }
  },
  data () {
    return {
      formContent: searchCondi,
      SearchForm: {
        scopeName:
          this.$store.state.SchemaTree[0].sceneCode === 'all_node'
            ? null
            : this.$store.state.SchemaTree[0].label,
        name: null,
        type: null,
        sceneId: null,
        carrierName: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      total: 0,
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.tbopt_delete',
          method: 'delFn'
        },
        // {
        //   id: 2,
        //   icon: '',
        //   vHas: ["incubatorAddCarrier"],
        //   text: 'public.net_param',
        //   method: 'netFn'
        // },
        {
          id: 4,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'device.reuse',
          method: 'useAgainFn'
        }
      ],
      choozeTableData: [],
      // 网络参数
      isShow: false,
      title: '',
      // 修改范围
      isShowEditShow: false,
      scopeArray: [],

      // 配置
      isShowConfig: false,
      // 把表格的数据也传递过去
      rowData: {},
      dialogVisible: false,
      isLoading: false,
      carrierDetail: null
    }
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (this.sysAdmin === 'noSysNoAdmin') {
      this.optareBtn.pop()
    }
    if (this.sysAdmin === 'isSysAdmin' || this.sysAdmin === 'isSysNoAdmin') {
      this.optareBtn.push({
        id: 3,
        icon: '',
        vHas: ['incubatorAddCarrier'],
        text: 'device.modify_customer',
        method: 'editScopeFn'
      })
    }
  },
  methods: {
    /** 分页 */
    getListFn () {
      // this.$refs.stable.getList()
      this.loading = true
      relayList(this.SearchForm, 'stop')
        .then(({ result }) => {
          this.tableData = result.result
          this.total = result.pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      } else if (row.level === 0 && row.id !== 'all') {
        // 一级范围
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    resetFn () {
      this.SearchForm = {
        scopeName:
          this.$store.state.SchemaTree[0].sceneCode === 'all_node'
            ? null
            : this.$store.state.SchemaTree[0].label,
        name: null,
        type: null,
        mac: null,
        carrierName: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      bus.$emit('initTree')
      this.treePathObj =
        this.$store.state.SchemaTree[0].sceneCode === 'all_node'
          ? null
          : this.$store.state.SchemaTree[0].label
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },

    /** 多条删除 */
    delFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const idList = this.choozeTableData.map(item => item.id)
          const query = {
            ids: idList.join(','),
            edited: 1
          }

          relayDel(query).then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条删除 */
    delRowFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const query = {
            ids: row.id,
            edited: 1
          }

          relayDel(query).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 网络参数弹出框 */
    netFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.isShow = true
      this.title = this.$t('device.add_net_param')
      this.$nextTick(() => {
        this.$refs.net.clearValidate()
      })
    },
    /** 修改范围 */
    editScopeFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const flag = this.distinguishTypeFn('scene_id')
      if (!flag) return this.$message.error($t('请选择同一客户'))
      this.isShowEditShow = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId =
          this.choozeTableData[0].scene_id + ''
        this.$refs.scopedId.dioForm.ids = this.choozeTableData
          .map(item => item.id)
          .join(',')
      })
    },
    /** 单条修改范围 */
    editScopeRowFn (row) {
      this.isShowEditShow = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId = row.sceneId + ''
        this.$refs.scopedId.dioForm.ids = row.id
      })
    },
    /** 区分勾选中的数据是否是同一种类型 */
    distinguishTypeFn (str) {
      if (this.choozeTableData.length === 1) return true

      const oneParam = this.choozeTableData[0]
      let flag = true
      for (const item of this.choozeTableData) {
        if (oneParam[str] !== item[str]) {
          flag = false
          break
        } else {
          flag = true
        }
      }
      return flag
    },
    /** 获取范围 */
    getSence () {
      shareScope({ tab: 1 }).then(res => {
        if (res.state.code == 200) {
          this.scopeArray = res.result.filter(item => {
            return item.id > 0
          })
        }
      })
    },
    /** 重新使用 */
    useAgainFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const idList = this.choozeTableData.map(item => item.id)
      const query = qs.stringify({ ids: idList.join(',') })
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          relayEdit(query, 'use').then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条重新使用 */
    async useAgainRowFn (row) {
      await this.$confirm('你确定要恢复使用该设备吗?')
      const query = qs.stringify({
        ids: row.id,
        status: 0
      })
      relayEdit(query, 'use').then(async ({ state }) => {
        await this.$resultHandle(state)
        this.getListFn()
      })
    },
    /** 配置 */
    configFn (row) {
      this.rowData = { ...row }
      this.isShowConfig = true
      this.title = $t('public.config_info')
      this.$nextTick(() => {
        this.$refs.config.activeName = 'ConfigNet'
      })
    },
    /** 详情 */
    detailFn (row) {
      bus.$emit('relayParam', row.id, row.relayCode)
    },
    /** 查找监测点详情 */
    carrierDetailFn (row) {
      const { type, carrierId } = row
      this.dialogVisible = true
      this.isLoading = true
      carrierDetail(type, carrierId)
        .then(({ result }) => {
          this.carrierDetail = result
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.bindPage {
  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
